import { createFileRoute } from '@tanstack/react-router';
import { WorkOrderBuildScreen } from '@/components/work-orders';

/**
 * The Work Orders build/detail screen for a single draft, reachable from the jobs list's
 * "New text send" / "Open" and directly by URL. Access is enforced by the parent
 * {@link /app/work-orders} layout guard (platform admin OR full admin) —
 * this child inherits it, so a hand-typed build URL can't slip past the area wall.
 */
export const Route = createFileRoute('/app/work-orders/$workOrderId')({
  component: WorkOrderBuildRoute,
});

function WorkOrderBuildRoute() {
  const { workOrderId } = Route.useParams();
  // Key on the id so navigating between drafts remounts the screen — its local edit state
  // (the draft's message/date/time) resets to the newly-loaded draft's saved content.
  return <WorkOrderBuildScreen key={workOrderId} workOrderId={workOrderId} />;
}
